import React from "react";

export default function OrganizationOverview() {
  return (
    <div>
      <h1>Organization Overview</h1>
    </div>
  );
}
